import http from '@/http/http'
import apiCfg from "../../config"
export default {
    //查询客户信息
    getUser: function () {
        return http.get(apiCfg.portalApi+"/user");
    },
    //登录
    submitLogin: function (params) {
        return http.post(apiCfg.portalApi+"/login", params);
    },
    //登录
    wxLogin: function (params) {
        return http.get(apiCfg.portalApi+"/wxlogin", params);
    },
    //添加客户的供应商/发货人/进口商
    addUser: function (params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/add", params)
    },
    //查询客户的供应商/发货人/进口商
    queryUser: function (params) {
        return http.get(apiCfg.portalApi+"/user/userInfo/list", params)
    },
    //修改客户的供应商/发货人/进口商
    modifyUser: function (params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/update", params)
    },
    //添加产品
    addProduct: function (params) {
        return http.post(apiCfg.portalApi+"/user/product/add", params)
    },
    //查询产品
    queryProduct: function (params) {
        return http.get(apiCfg.portalApi+"/user/product/list", params)
    },
    //删除产品
    delProduct: function (data, params) {
        return http.post(apiCfg.portalApi+"/user/product/del", data, params)
    },
    //修改产品
    updateProdct: function (params) {
        return http.post(apiCfg.portalApi+"/user/product/update", params)
    },
    // //批量修改状态
    //  updateProdctStatus: function (params) {
    //     return http.post(apiCfg.managerApi+"user/product/update/status", params)
    // },
    // //批量删除产品
    //  batchDelProdct: function (params) {
    //     return http.post(apiCfg.managerApi+"user/product/del/batch", params)
    // },
    
    //修改客户信息
    updateAccount: function (params) {
        return http.post(apiCfg.portalApi+"/user/update", params)
    },
    //订单分页列表
    orderList: function (params) {
        return http.get(apiCfg.portalApi+"/order/list", params)
    },
    //GET /portal/api/1.0/order/count查询订单数量
    orderListCount: function (params) {
        return http.get(apiCfg.portalApi+"/order/count", params)
    },
    //查询订单详情
    findOrder: function ( params) {
        return http.get(apiCfg.portalApi+'/order/find', params)
    },
    //查询消息
    queryMsg: function (params) {
        return http.get(apiCfg.portalApi+"/user/msg", params)
    },
    //用户余额
    balanceM() {
        return http.get(apiCfg.portalApi+"/user/center/balance")
    },
    //业务统计
    staticsM() {
        return http.get(apiCfg.portalApi+"/user/center/order_statistics")
    },
    //问题件
    abnormal() {
        return http.get(apiCfg.portalApi+"/user/center/abnormal_order_list")
    },
    //文件下载
    orderFile() {
        return http.get(apiCfg.portalApi+"/user/center/order_file_list")
    },
    //用户通知
    logstatus() {
        return http.get(apiCfg.portalApi+"/user/center/order_logstatus_list")
    },
    //查询交易订单
    findList( params) {
        return http.get(apiCfg.portalApi+"/order/transactionRecord/list", params)
    },
    // 查看交易明细
    detailList(params) {
        return http.get(apiCfg.portalApi+"/order/transactionRecord/detail", params)
    },
    //解析excel文件
    parseExcel(params) {
        return http.post(apiCfg.portalApi+"/file/parseExce", params)
    },
    //查询参数GET /manager/api/1.0/sys/param/list
    listParams(params) {
        return http.get( apiCfg.managerApi+ "/sys/param/list",params)
    },
    //查询参数GET /manager/api/1.0/sys/param/list
    listParams2(params) {
        return http.get( apiCfg.managerApi+ "/quote/channel/list",params)
    },
    // 查看送货地
    getPort(params) {
        return http.get(apiCfg.portalApi+"/order/getPort", params)
    },
    //下单
    addOrder(params) {
        return http.post(apiCfg.portalApi+"/order/add", params)
    },
    //取消订单
    cancel(params) {
        return http.post(apiCfg.portalApi+"/order/cancel", params)
    },
    //修改客户密码
    updatePass(params) {
        return http.post(apiCfg.portalApi+"/user/updatePassword", params)
    },
    //删除客户的供应商/发货人/进口商
    updateUser(params) {
        return http.post(apiCfg.portalApi+"/user/userInfo/del", params)
    },
    //快捷登录
    fastLogin(params) {
        return http.post(apiCfg.portalApi+"/fast_login", params)
    },
    //查询公共订单
    search(params){
        return http.get(apiCfg.portalApi+"/searchOrder",params)
    },
    //客户新增收款申请
    submitPayment(params){
        return http.post(apiCfg.portalApi+"/order/submitPayment",params)
    },
    //客户实名认证
    userAuthe(params){
        return http.get(apiCfg.portalApi+"/user/userAuthe",params)
    },
    bindingWeixin(params){
        return http.get(apiCfg.portalApi+"/user/bindingWeixin",params)
    },
    unbindWeixin(params){
        return http.get(apiCfg.portalApi+"/user/unbindWeixin",params)
    },
    addFile(params){
        return http.post( apiCfg.managerApi+ "/report/update",params)
    },
    getTimeData(params){
        return http.get(apiCfg.portalApi+"/order/getTimeData",params)
    },
    selSql(params){
        return http.get( apiCfg.managerApi+ "/report/selSql",params)
    },
    addSql(params){
        return http.get( apiCfg.managerApi+ "/report/addSql",params)
    },
    updateSql(params){
        return http.get( apiCfg.managerApi+ "/report/updateSql",params)
    },
    delSql(params){
        return http.get( apiCfg.managerApi+ "/report/delSql",params)
    },
    setSql(params){
        return http.get( apiCfg.managerApi+ "/report/setSql",params)
    },
    getTracking(params){
        return http.get( apiCfg.managerApi+ "/report/getTracking",params)
    },
    setCreate(params){
        return http.get(apiCfg.managerApi+ "/report/setCreate",params)
    },
    // 修改订单1
    update1(params){
        return http.post(apiCfg.portalApi+"/order/update1", params)
    },
    //新增订单文件
    addFile(params) {
        return http.post(apiCfg.portalApi+"/order/file/add", params)
    },
    // 修改订单2
    update2(params){
        return http.post(apiCfg.portalApi+"/order/update2", params)
    },
     //查询尾程柜子
    findWContaienr(params){
        return http.get(apiCfg.managerApi+ "/wc/container/list",params);
    },
       //查询柜子物流日志
    containerLogistics(params){
        return http.get(apiCfg.managerApi+ "/container/find/containerLogistics", params)
    },
     //查看订单详情
    orderDetails( params) {
        return http.get(apiCfg.managerApi+ "/order/detail", params)
    },
      getOrderingChannel(params){
        return http.get(apiCfg.managerApi+ "/ordering/getOrderingChannel",params)
    },
      //柜子详情
    cabView( params) {
        return http.get(apiCfg.managerApi+ "/container/view", params)
    },
       selModel(params){
        return http.get(apiCfg.managerApi+ "/report/selModel", params)
    },
        //代理列表
    listAgent2( params) {
        return http.get(apiCfg.managerApi+ "/agent/list2", params)
    },
     //代理分页列表
    listAgent( params) {
        return http.get(apiCfg.managerApi+ "/agent/list", params)
    },
       //柜子里面尾程订单
    contOrderList(params) {
        return http.get(apiCfg.managerApi+ "/order/tail/container/list", params)
    },
    //批量下载唛头
    mtBDown(params){
        return http.post(apiCfg.managerApi+"/report/mai_tou3_Btach", params,{
            responseType: 'arraybuffer', // 确保拼写正确，且位置正确 
          })
    },

    downloadTemp() {
        return http.get(apiCfg.managerApi+ "/file/template",{
            responseType: 'blob', // 确保拼写正确，且位置正确 
          })
    },
}